import { OktaAuthOptions } from '@okta/okta-auth-js';

import environment from './environment';

const oktaAuthConfig: OktaAuthOptions = {
  clientId: environment.oktaClientId,
  issuer: environment.oktaIssuer,
  pkce: true,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email', 'uma:read', 'uma:write'],
  // okta-auth-js 8 defaults to leaving access tokens undecoded; TokenManager
  // reads authState.accessToken.claims (the token-hook-enriched role/org/
  // casbin_policies claims), so decoding must stay explicitly enabled.
  decodeAccessTokens: true,
  transactionManager: {
    saveNonceCookie: false,
    saveParamsCookie: false,
    saveStateCookie: false
  }
};

export { oktaAuthConfig };